<template>
  <campsite-subsection
    class="reviews"
    :class="{ desktop: $isDesktop }"
    :open="!!campsiteRateCount"
    name="reviews"
    data-test="campsite-reviews-subsection"
  >
    <template #title>
      <translate>Reviews</translate>
    </template>
    <template #contents>
      <campsite-reviews-new
        :campsite-name="campsiteName"
        :campsite-slug="campsiteSlug"
        :campsite-rate-count="campsiteRateCount"
        :campsite-rating="campsiteRating"
        :review-id="reviewId"
        @data-fetched="$emit('data-fetched')"
      />
    </template>

    <template v-if="!campsiteRateCount" #footer> &#8203; </template>
  </campsite-subsection>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component({
  emits: ['data-fetched'],
})
class CampsiteReviewsSubsection extends Vue {
  @Prop({ required: true })
  campsiteName: string

  @Prop({ required: true })
  campsiteSlug: string

  @Prop({ required: true })
  campsiteRateCount: number

  @Prop({ required: true })
  campsiteRating: number

  @Prop()
  reviewId?: string
}

export default toNative(CampsiteReviewsSubsection)
</script>

<style scoped>
.reviews.campsite-subsection {
  padding: 1em 0 0;
}

.reviews :deep(header) {
  padding: 0 1.4em;
}

/* desktop & tablet */
.reviews.campsite-subsection.desktop {
  padding: 1em var(--page-width-padding) 0;
}

.reviews.desktop :deep(header) {
  padding: 0;
}

.reviews.desktop :deep(.campsite-reviews-filters .slideout-panel-content) {
  max-width: 30em;
}

.reviews.desktop :deep(.campsite-reviews-filters .slideout-panel) {
  justify-content: center;
  width: 100%;
}

.reviews.desktop :deep(.campsite-reviews-filters-content) {
  padding-top: 2em;
}

.reviews.desktop :deep(.showing-reviews-note) {
  font-size: var(--body);
  margin-top: 1em;
}

.reviews.desktop :deep(.reviews-filter-button) {
  border-radius: 0.5em;
  border: 0.1em solid var(--colour-blue);
  margin: 1.25em auto 1.25em 0;
  width: auto;
  min-width: 35ch;
}

.reviews.desktop :deep(.reviews-filter-button:hover),
.reviews.desktop :deep(.reviews-filter-button:active),
.reviews.desktop :deep(.reviews-filter-button:focus-visible) {
  box-shadow: none;
  background: #ced6da;
  border-color: #ced6da;
  outline: none;
}
</style>
